import React from "react";
import { useSpring, animated } from "@react-spring/web";

const SectionData = () => {
  const stats = [
    { id: 1, name: "Production"},
    { id: 2, name: "Conditionement"},
    { id: 3, name: "Logistique"},
    { id: 4, name: "Export"},
  ];

  // Animation pour chaque élément
  const props = useSpring({ to: { opacity: 1 }, from: { opacity: 0 }, reset: true });

  return (
    <div className="bg-gradient-to-b from-[#9ec083] to-[#69B578] text-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Responsive layout */}
        <dl className="flex flex-col sm:flex-row justify-center items-center text-center gap-y-6 sm:gap-y-0">
          {stats.map((stat, index) => (
            <animated.div
              key={stat.id}
              style={props}
              className={`relative flex flex-col sm:flex-row items-center sm:gap-x-4 gap-y-2 px-6 sm:px-8 ${
                // Ajout des bordures selon la version
                index !== stats.length - 1 
                  ? "border-b sm:border-b-0 sm:border-r border-white/50"
                  : "border-b border-white/50 sm:border-b-0"
              }`}
            >
              <dt className="text-4xl font-bold sm:text-5xl">{stat.name}</dt>
            </animated.div>
          ))}
        </dl>
      </div>
    </div>
  );
};

export default SectionData;